import { render } from "./VThead.vue?vue&type=template&id=50aa5de8"
import script from "./VThead.vue?vue&type=script&lang=js"
export * from "./VThead.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__